<template>
  <div class="logistic-wrapper">
    <div class="logistic-container">
      <div v-if="product" class="panel-container">

        <div class="header-section">
          <div class="header-top-row">
            <div class="product-title-group">
              <div class="actions">
                <i v-if="notificationsToSee" @click="showNotificationsModal = true" class="fas fa-exclamation-circle notification-btn" title="Powiadomienia"></i>
                <i v-if="product.productAlert" @click="showProductAlertModal(product.productAlert)" class="fas fa-exclamation-triangle alert-btn" title="Alert"></i>
              </div>
              <h2>
                <span v-if="selectedItemData != null && selectedItemData.ignored" class="text-muted text-decoration-line-through">
                  {{ product.name }} <small>[{{selectedItemData.ignoredStatusStr}}]</small>
                </span>
                <span v-else>{{ product.name }}</span>
              </h2>
            </div>

            <div v-if="drugstore" class="drugstore-group">
              <h3>
                <i v-if="isSourceDataObsolete" @click="showSourceDataObsoleteAlertModal()" class="fas fa-exclamation-triangle alert-btn small-icon"></i>
                {{ drugstore.name }}
              </h3>
            </div>
          </div>

          <div class="header-meta-row">
            <div class="meta-tags">
              <span class="meta-pill">BLOZ: <b>{{ product.bloz }}</b></span>
              <span class="meta-pill">EAN: <b>{{ product.ean }}</b></span>
<!--              <span class="meta-pill">Kod: <b>{{ product.barcode }}</b></span>-->
              <span class="meta-pill producer">Prod: <b>{{ product.manufacturer }}</b></span>
            </div>
            <div v-if="drugstore" class="meta-tags right">
              <span class="meta-pill id-pill"><b>{{ drugstore.drugstoreClientId }}</b></span>
            </div>
          </div>
        </div>

        <div class="data-tabs-container">
          <b-tabs v-model="activeTab" pills class="compact-tabs" content-class="tab-content-area">

            <b-tab title="Sprzedaż">
              <div v-if="selling" class="data-section">
                <div class="section-header-row">
                  <span class="section-label">Analiza okresowa</span>
                </div>
                <div class="dense-list">
                  <div class="list-item"><span><i class="fas fa-level-down-alt action-icon" @dblclick.stop="selectValue(selling.soldIn30Days)"></i> 30 dni</span> <b class="val-primary">{{ selling.soldIn30Days }}</b></div>
                  <div class="list-item"><span><i class="fas fa-level-down-alt action-icon" @dblclick.stop="selectValue(selling.soldIn60Days)"></i> 60 dni</span> <b class="val-primary">{{ selling.soldIn60Days }}</b></div>
                  <div class="list-item"><span><i class="fas fa-level-down-alt action-icon" @dblclick.stop="selectValue(selling.soldIn90Days)"></i> 90 dni</span> <b class="val-primary">{{ selling.soldIn90Days }}</b></div>
                  <div class="list-item"><span><i class="fas fa-level-down-alt action-icon" @dblclick.stop="selectValue(selling.soldIn120Days)"></i> 120 dni</span> <b class="val-primary">{{ selling.soldIn120Days }}</b></div>
                  <div class="list-item"><span><i class="fas fa-level-down-alt action-icon" @dblclick.stop="selectValue(selling.soldIn150Days)"></i> 150 dni</span> <b class="val-primary">{{ selling.soldIn150Days }}</b></div>
                  <div class="list-item"><span><i class="fas fa-level-down-alt action-icon" @dblclick.stop="selectValue(selling.soldIn180Days)"></i> 180 dni</span> <b class="val-primary">{{ selling.soldIn180Days }}</b></div>
                  <div class="list-item"><span><i class="fas fa-level-down-alt action-icon" @dblclick.stop="selectValue(selling.soldIn300Days)"></i> 300 dni</span> <b class="val-primary">{{ selling.soldIn300Days }}</b></div>
                  <div class="list-item"><span><i class="fas fa-level-down-alt action-icon" @dblclick.stop="selectValue(selling.soldIn360Days)"></i> 360 dni</span> <b class="val-primary">{{ selling.soldIn360Days }}</b></div>
                </div>
              </div>
              <div v-else class="loading-placeholder">
                <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                <span>Wczytywanie...</span>
              </div>
            </b-tab>

            <b-tab title="Magazyn">
              <div v-if="stock" class="data-section">
                <div class="section-header-row">
                  <span class="section-label">Stany i parametry</span>
                </div>
                <div class="dense-list">
                  <div class="list-item highlight-row"><span><i class="fas fa-level-down-alt action-icon" @dblclick.stop="selectValue(stock.activeStock)"></i> Aktywny</span> <b class="val-success">{{ stock.activeStock }}</b></div>
                  <div class="list-item"><span><i class="fas fa-level-down-alt action-icon" @dblclick.stop="selectValue(stock.bufferStock)"></i> Bufor</span> <b>{{ stock.bufferStock }}</b></div>
                  <div class="list-item"><span><i class="fas fa-level-down-alt action-icon" @dblclick.stop="selectValue(stock.holdonStock)"></i> Wstrzymane</span> <b>{{ stock.holdonStock }}</b></div>
                  <div class="list-item"><span><i class="fas fa-level-down-alt action-icon" @dblclick.stop="selectValue(stock.sumStock)"></i> Sumaryczny</span> <b>{{ stock.sumStock }}</b></div>
                  <div class="list-item"><span><i class="fas fa-level-down-alt action-icon" @dblclick.stop="selectValue(stock.packageStock)"></i> Stan pakietu</span> <b>{{ stock.packageStock }}</b></div>
                  <div class="list-item"><span><i class="fas fa-level-down-alt action-icon" ></i> </span> <b> - </b></div>
                  <div class="list-item"><span><i class="fas fa-level-down-alt action-icon" @dblclick.stop="selectValue(stock.norm)"></i> Norma</span> <b>{{ stock.norm }}</b></div>
                  <div class="list-item"><span><i class="fas fa-level-down-alt action-icon" @dblclick.stop="selectValue(stock.minStock)"></i> Min. stan</span> <b>{{ stock.minStock }}</b></div>
                  <div class="list-item separator-top"><span>Min. cena zak.</span> <b>{{ stock.minActivePurchasePrice }} zł</b></div>
                  <div class="list-item separator-top"><span>Maks. cena zak.</span> <b>{{ stock.maxActivePurchasePrice }} zł</b></div>
                </div>
              </div>
              <div v-else class="loading-placeholder">
                <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                <span>Wczytywanie...</span>
              </div>
            </b-tab>

            <b-tab title="Wykres">
              <div v-if="selling" class="data-section full-height">
                <div class="section-header-row">
                  <span class="section-label">Trend sprzedaży</span>
                </div>
                <div class="chart-container">
                  <div v-if="isDetailSellingEmpty" class="empty-chart">
                    <span>Brak danych</span>
                  </div>
                  <vue-echarts v-else :option="barChartOptions" style="height: 148px; width: 100%;" autoresize/>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>

      <div v-else class="product-data-placeholder">
        <i class="fas fa-box-open mb-2"></i>
        <span>Wybierz towar z listy</span>
      </div>
    </div>

    <b-modal v-model="showNotificationsModal"
             id="item-notifications-modal"
             scrollable
             title="Uwagi do pozycji"
             title-class="font-16 fw-bold"
             hide-footer
             size="lg"
             centered
             style="z-index:99999!important;"
    >
      <div v-if="notificationsToSee">
        <ScrollableListView
            :listContent="selectedItemData.notifications"
            ulStyle="max-height:300px; text-align:left;"
        />
      </div>
    </b-modal>
  </div>
</template>




<script>
import {VueEcharts} from "vue3-echarts";
import ScrollableListView from "@/components/widgets/ScrollableListView.vue";
import Swal from "sweetalert2";

export default {
  name: "ProductLogisticDetailsSection2",
  components: {ScrollableListView, VueEcharts},
  props: {
    product: {type: Object, required: false},
    drugstore: {type: Object, required: false},
    stock: {type: Object, required: false},
    selling: {type: Object, required: false},
    sellingDetails: {type: Object, required: false},
    selectedItemData: {type: Object, required: false},
    lastStockDates: {type: Object, required: false},
  },
  emits: ['onSelectValue', 'onContainerMounted'],
  data() {
    return {
      isFixed: false,
      componentHeight: 0,
      showNotificationsModal:false,
      activeTab: 0,
    };
  },
  computed: {
    notificationsToSee(){
      if(this.selectedItemData && this.selectedItemData.notifications){
        var notifications = this.selectedItemData.notifications.replace(";","")
        return notifications.trim().length > 0
      }
      return false
    },
    isDetailSellingEmpty(){
      return !this.sellingDetails || !this.sellingDetails.sellingDetails || this.sellingDetails.sellingDetails.length === 0
    },
    isSourceDataObsolete(){
      if(!this.lastStockDates){
        return true;
      }

      if(!this.lastStockDates.lastSellingDate || !this.lastStockDates.lastSupplyDate || !this.lastStockDates.lastStockCalcDate){
        return true;
      }

      if(this.lastStockDates && this.lastStockDates.lastSellingDate && this.lastStockDates.lastSupplyDate && this.lastStockDates.lastStockCalcDate){
        const stockDate = new Date(this.lastStockDates.lastSupplyDate);
        const sellingDate = new Date(this.lastStockDates.lastSellingDate);
        const lastStockCalcDate = new Date(this.lastStockDates.lastStockCalcDate);

        const currentDate = new Date();
        const diffStockDays = Math.floor((currentDate - stockDate) / (1000 * 60 * 60 * 24));
        const diffSellingDays = Math.floor((currentDate - sellingDate) / (1000 * 60 * 60 * 24));
        const diffStockCalcDays = Math.floor((currentDate - lastStockCalcDate) / (1000 * 60 * 60 * 24));
        return diffStockDays > 1 || diffSellingDays > 1 || diffStockCalcDays > 1;
      }
      return false;
    },
    barChartOptions() {
      // Grupowanie sprzedaży po dacie
      const salesByDate = {};
      console.log("Generating bar chart options for product:", this.product);
      console.log(this.sellingDetails.sellingDetails)

      if (this.isDetailSellingEmpty) {
        return {};
      }
      this.sellingDetails.sellingDetails.forEach(item => {
        if (!salesByDate[item.sellingDate]) salesByDate[item.sellingDate] = 0;
        salesByDate[item.sellingDate] += item.soldAmount;
      });
      const labels = Object.keys(salesByDate).sort();
      const data = labels.map(date => salesByDate[date]);
      return {
        title: {
          text: "Sprzedaż dzienna (ilość)",
          left: "center",
          textStyle: {
            color: "#323130",
            fontWeight: "bold",
            fontSize: 16
          }
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          borderColor: "#0078D4",
          borderWidth: 1,
          textStyle: {color: "#323130"}
        },
        grid: {
          left: 40,
          right: 20,
          bottom: 40,
          top: 60
        },
        xAxis: {
          type: "category",
          data: labels,
          axisLabel: {
            color: "#323130",
            fontWeight: "bold"
          },
          axisLine: {lineStyle: {color: "#E1DFDD"}},
          axisTick: {show: false}
        },
        yAxis: {
          type: "value",
          minInterval: 1,
          axisLabel: {
            color: "#323130",
            fontWeight: "bold"
          },
          splitLine: {lineStyle: {color: "#E1DFDD"}}
        },
        series: [
          {
            name: "Sprzedaż dzienna",
            type: "bar",
            data,
            itemStyle: {
              color: "#0078D4",
              borderRadius: [3, 3, 0, 0],
              borderColor: "#005A9E",
              borderWidth: 2
            },
            barWidth: "50%"
          }
        ]
      };
    }
  },
  methods:{
    showProductAlertModal(message){
      Swal.fire({
        title: 'Problem z towarem',
        input: 'textarea',
        text: `Znaleziono następujące problemy z tym towarem:\n`,
        inputValue: `${message}`,
        icon: 'warning',
        confirmButtonText: 'OK',
        inputAttributes: {
          readonly: true,           // use this so users can copy text
          style: 'height: 180px;'   // optional sizing
        },
        customClass: {
          popup: 'swal-custom-popup'
        }
      });

    },
    showSourceDataObsoleteAlertModal(){

      const message = `Dane źródłowe dla tej apteki są przestarzałe. Ostatnie daty aktualizacji:\n` +
          `- Ostatnia sprzedaż: ${this.lastStockDates.lastSellingDate ? new Date(this.lastStockDates.lastSellingDate).toLocaleDateString() : 'Brak danych'}\n` +
          `- Ostatnie dostawy: ${this.lastStockDates.lastSupplyDate ? new Date(this.lastStockDates.lastSupplyDate).toLocaleDateString() : 'Brak danych'}\n` +
          `- Ostatnie przeliczenie stanów: ${this.lastStockDates.lastStockCalcDate ? new Date(this.lastStockDates.lastStockCalcDate).toLocaleDateString() : 'Brak danych'}\n\n` +
          `Skontaktuj się z administratorem systemu w celu aktualizacji danych.`;

      Swal.fire({
        title: 'Dane źródłowe przestarzałe',
        input: 'textarea',
        text: "",
        inputValue: `${message}`,
        icon: 'warning',
        confirmButtonText: 'OK',
        inputAttributes: {
          readonly: true,           // use this so users can copy text
          style: 'height: 180px;'   // optional sizing
        },
        customClass: {
          popup: 'swal-custom-popup'
        }
      });

    },
    selectValue(value) {
      console.log("Selected value:", value);
      if (parseFloat(value) % 1 === 0.5) {
        value = Math.ceil(value)
      } else {
        value = Math.round(value)
      }
      this.$emit('onSelectValue', value);
    }
  },
  mounted() {
    this.componentHeight = this.selectedItemData && this.$el.clientHeight < 268 ? 268 : this.$el.clientHeight;
    this.$emit('onContainerMounted', this.componentHeight);
  },
  watch: {
    activeTab() {
      this.$nextTick(() => {
        window.dispatchEvent(new Event('resize'));
      });
    },

    selectedItemData: {
      handler() {
        this.componentHeight = this.selectedItemData && this.$el.clientHeight < 268 ? 268 : this.$el.clientHeight;
        this.$emit('onContainerMounted', this.componentHeight);
      },
      deep: true,
    },
  }

};
</script>

<style scoped>
/* --- BASE LAYOUT FOR 600x400px --- */
.logistic-wrapper {
  height: 100%;
  width: 100%;
  overflow: hidden; /* Zapobiega wychodzeniu poza okno */
  background: #ffffff;
}

.logistic-container {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 12px; /* Lekko mniejszy font bazowy */
  color: #333;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.panel-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* --- HEADER SECTION (Compact) --- */
.header-section {
  padding: 10px 12px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  flex-shrink: 0; /* Header nie może się kurczyć */
}

.header-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.product-title-group {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
}

.product-title-group h2 {
  margin: 0;
  font-size: 15px; /* Kompaktowy nagłówek */
  font-weight: 600;
  color: #0078D4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.actions {
  display: flex;
  gap: 6px;
}

.drugstore-group h3 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  text-align: right;
  white-space: nowrap;
}

/* Meta Pills (Chips style) */
.header-meta-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.meta-tags {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.meta-pill {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 1px 6px;
  font-size: 11px;
  color: #6c757d;
}

.meta-pill b {
  color: #212529;
}

.meta-pill.producer {
  border-color: #cce5ff;
  background-color: #e8f4ff;
  color: #004085;
}

.meta-pill.id-pill {
  border-color: #d1ecf1;
  background-color: #e2e6ea;
}

/* --- TABS & CONTENT --- */
.data-tabs-container {
  flex-grow: 1; /* Zajmuje resztę miejsca */
  overflow: hidden; /* Kontent będzie scrollowany wewnątrz */
  display: flex;
  flex-direction: column;
}

/* Override Bootstrap Tabs Styling for Compactness */
:deep(.compact-tabs) {
  height: 100%;
  display: flex;
  flex-direction: column;
}

:deep(.compact-tabs .nav-pills) {
  padding: 6px 12px 0;
  border-bottom: 1px solid #dee2e6;
  flex-shrink: 0;
  gap: 4px;
}

:deep(.compact-tabs .nav-link) {
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px 4px 0 0;
  color: #6c757d;
  background: transparent;
  border: 1px solid transparent;
  margin-bottom: -1px;
}

:deep(.compact-tabs .nav-link.active) {
  color: #0078D4;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
  font-weight: 600;
}

:deep(.tab-content-area) {
  flex-grow: 1;
  overflow-y: auto; /* Scroll wewnątrz tabów */
  padding: 10px 12px;
  height: 100%;
}

/* --- DATA SECTIONS (The List View) --- */
.section-header-row {
  margin-bottom: 8px;
  border-bottom: 2px solid #f1f3f5;
  padding-bottom: 4px;
}

.section-label {
  text-transform: uppercase;
  font-size: 10px;
  letter-spacing: 0.5px;
  color: #adb5bd;
  font-weight: 700;
}

/* Dense List Styling - replaces grid-2col */
.dense-list {
  display: grid;
  grid-template-columns: 1fr 1fr; /* 2 kolumny, czytelne na 600px */
  gap: 0 20px; /* Odstęp między kolumnami */
}

.list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px 0;
  border-bottom: 1px solid #f8f9fa;
  font-size: 12px;
}

.list-item:hover {
  background-color: #f8f9fa;
}

.list-item span {
  color: #6c757d;
  display: flex;
  align-items: center;
}

.list-item b {
  font-weight: 600;
  color: #212529;
}

.separator-top {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #dee2e6;
}

/* Colors for values */
.val-primary { color: #0078D4 !important; }
.val-success { color: #107C10 !important; }

/* Action Icon */
.action-icon {
  font-size: 10px;
  margin-right: 6px;
  color: #ced4da;
  cursor: pointer;
  transition: color 0.2s;
}
.list-item:hover .action-icon { color: #0078D4; }

/* --- CHART SECTION --- */
.full-height {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.chart-container {
  flex-grow: 1;

  position: relative;
}

.empty-chart {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #adb5bd;
  font-style: italic;
  background: #f8f9fa;
  border-radius: 4px;
}

/* --- PLACEHOLDERS --- */
.loading-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 150px;
  color: #6c757d;
  gap: 10px;
}

.product-data-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: #f8f9fa;
  color: #adb5bd;
  font-size: 13px;
  text-align: center;
  padding: 20px;
}

.product-data-placeholder i {
  font-size: 24px;
  margin-bottom: 8px;
  opacity: 0.5;
}

/* Buttons */
.notification-btn { color: #f0ad4e; cursor: pointer; }
.alert-btn { color: #d9534f; cursor: pointer; }
.small-icon { font-size: 11px; margin-right: 4px; }

/* Scrollbar beautification for small window */
::-webkit-scrollbar { width: 6px; height: 6px; }
::-webkit-scrollbar-track { background: #f1f1f1; }
::-webkit-scrollbar-thumb { background: #ccc; border-radius: 3px; }
::-webkit-scrollbar-thumb:hover { background: #bbb; }
</style>
